import React, { useCallback, useState, useEffect } from "react";
import { cn } from "../../utils/cn";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const NavbarProfilePopover = ({
  onLogoutClick,
  activeSection = null,
  className,
  style,
  unreadCount,
}) => {
  const navigate = useNavigate();
  const { admin } = useSelector((state) => state.auth);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640);
    };

    // Check on mount
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  console.log("admin", admin);

  const menuItems = [
    {
      id: "viewprofile",
      label: "View Profile",
      onClick: () => navigate("/admin/profile"),
      isActive: activeSection === "viewprofile",
      showAlways: true,
    },
    {
      id: "changepassword",
      label: "Change Password",
      onClick: () => navigate("/admin/change-password"),
      isActive: activeSection === "changepassword",
      showAlways: true,
    },
    {
      id: "messages",
      label: "Messages",
      onClick: () => navigate("/admin/full-chat-view"),
      isActive: activeSection === "messages",
      showAlways: false, // Only show on mobile
    },
    {
      id: "notifications",
      label: "Notifications",
      isActive: activeSection === "notifications",
      showAlways: false, // Only show on mobile
    },
    {
      id: "logout",
      label: "Logout",
      onClick: onLogoutClick,
      isActive: false,
      showAlways: true,
    },
  ];

  // Filter menu items based on screen size
  const filteredMenuItems = menuItems.filter(
    (item) => item.showAlways || isMobile
  );

  const handleKeyDown = useCallback((e, onClick) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick?.();
    }
  }, []);

  return (
    <div
      role="menu"
      className={cn(
        "flex flex-col transition-all duration-300",
        "theme-light:bg-white theme-light:border theme-light:border-[#C2C9D2]",
        "theme-dark:bg-[#282136] theme-dark:border theme-dark:border-[#FFFFFF33]",
        className
      )}
      style={{
        width: "224px",
        borderRadius: "16px",
        borderWidth: "1px",
        padding: "12px",
        backgroundColor: "var(--navbar-popover-bg)",
        borderColor: "var(--navbar-popover-border)",
        ...style,
      }}
    >
      <div className="flex flex-col gap-2">
        {filteredMenuItems.map((item) => (
          <button
            key={item.id}
            role="menuitem"
            tabIndex={0}
            className={cn(
              "flex items-center text-left border-none bg-transparent cursor-pointer transition-all duration-300",
              "hover:bg-gradient-to-r hover:from-[rgba(123,2,203,0.1)] hover:to-[rgba(193,2,203,0.1)]",
              "focus:outline-2 focus:outline-offset-2 focus:outline-[var(--color-primary)]",
              {
                "bg-gradient-to-r from-[rgba(123,2,203,0.1)] to-[rgba(193,2,203,0.1)]":
                  item.isActive,
              }
            )}
            style={{
              width: "100%",
              borderRadius: "8px",
              padding: "12px",
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              color: "var(--navbar-text-color)",
            }}
            onClick={item.onClick}
            onKeyDown={(e) => handleKeyDown(e, item.onClick)}
          >
            {item.label}
            {item.id === "messages" && unreadCount > 0 && (
              <span className="ml-2 text-[10px] font-bold text-white bg-[var(--color-primary)] rounded-full w-5 h-5 flex items-center justify-center">
                {unreadCount > 99 ? "99+" : unreadCount}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavbarProfilePopover;
